import React, { useEffect, useRef, useState } from "react";
import { Payload } from "modules/cart/types/cart"
import Amount from "utils/amount";
//UI
import {Avatar, AvatarImage} from '@/components/ui/avatar';
import { Button } from "@/components/ui/button";
import {Minus, Plus, Trash,X} from "lucide-react";
import { Link } from "react-router-dom";
import { AddCartMethod } from "../types/add-cart-methods";

// interface CartElementUIProops {
//     product_id:number,
//     slug:string,
//     sku:string
//     store_id:number,
//     store_name:string,
//     brand:string,
//     image_url:string,
//     logo_url:string,
//     name:string,
//     category_id:number,
//     price:number,
//     quantity:number,
//     method:AddCartMethod,
//     singleQtyButtons:boolean,
//     PlusMinusCallback:(payload:Payload)=>void
//     RemoveCallBack:(payload:Payload)=>void
// }

// export const CartElementUI:React.FC<CartElementUIProops> = ( props ) => {    
//     return (
//     <div className="mt-4 text-sm max-w-60">
//         <div className="flex flex-row gap-2">
//             <div className="min-w-20">
//                 <img className="Image-80" src={props.image_url} alt={""}/>
//             </div>  
//             <div className="px-2 w-full">
//                 <div className="flex flex-row w-full mb-2">
//                     <Link to={"/"+props.slug}>
//                         <span className="font-semibold">{props.name}</span>
//                     </Link>
//                     {/* <X className="w-5"/>                 */}
//                 </div>
//                 <div className="my-2 flex flex-row items-center gap-2 w-full justify-between">
//                     <Avatar>
//                         <AvatarImage src={props?.logo_url}/>
//                     </Avatar>
//                     <div className="w-full flex flex-row items-center justify-between gap-2">
//                         <span className="text-muted-foreground max-w-24 line-clamp-1 break-all">{props.store_name}</span>      
//                         <div className="flex justify-between gap-4">
//                             <span>{(true)&&(<>{props.quantity}  Un.</>)}</span>
//                             <span className="font-bold ml-2">
//                                 <Amount 
//                                 amount={props.price} 
//                                 currency="CLP" 
//                                 locale="es-CL" 
//                                 />
//                             </span>  
//                         </div>                       
//                     </div>                    
//                 </div>
//                 { (props.singleQtyButtons) &&<AddDeleteCartButtons {...props}  className="my-3 justify-end"/>}
//             </div>            
//         </div>                  
//     </div>);
// }



interface AddDeleteCartButtonsProps extends React.HTMLAttributes<HTMLDivElement>{
    product_id:string,
    sku:string,    
    name:string,
    category_id:number,
    quantity:number,
    displayQuantity?:number,
    method:AddCartMethod,
    showDelete?:boolean,
    disabled?:boolean,
    setQty?: (qty:number) => void,
    PlusMinusCallback: (payload:Payload) => void
    RemoveCallBack?:(payload:Payload) => void
}
export const AddDeleteCartButtons = React.forwardRef<HTMLDivElement,AddDeleteCartButtonsProps> (({className,showDelete=true,...props},ref) => {
    const [localQuantity, setLocalQuantity] = useState(props.quantity);
    const [displayQuantity, setDisplayQuantity] = useState(props.displayQuantity??props.quantity);
    const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);
    const pendingOperationRef = useRef<number | null>(null);    
    useEffect(() => {
        setLocalQuantity(props.quantity);
        setDisplayQuantity(props.displayQuantity??props.quantity);
    }, [props.quantity, props.displayQuantity]);

    const handleAddClick = (qty:number) => {      
        const newQuantity = Math.max(0, localQuantity + qty);
        const newDisplayQuantity = Math.max(0, displayQuantity + qty);

        setLocalQuantity(newQuantity);     
        setDisplayQuantity(newDisplayQuantity);
        pendingOperationRef.current = newQuantity;
        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
        }
        debounceTimerRef.current = setTimeout(() => {
            if (pendingOperationRef.current !== null) {
                if (props.setQty) {
                    props.setQty(pendingOperationRef.current);
                }
                props.PlusMinusCallback(
                {
                    id:props.product_id,
                    sku: props.sku,        
                    name:props.name,   
                    category_id:props.category_id,
                    quantity:pendingOperationRef.current,
                    method:"SAME"
                } );
            }
            pendingOperationRef.current = null;
            debounceTimerRef.current = null;
        }, 1000);
    };  

    const handleRemoveClick = () => {
        if (props.RemoveCallBack){        
            props.RemoveCallBack(
                {
                    id:props.product_id,
                    sku: props.sku, 
                    category_id:props.category_id,
                    name:props.name,               
                    quantity:0                
                }
            );}
    }
    return (
        <div className={`flex flex-row  items-center justify-center  gap-3 text-sm ${className}`} ref={ref}>
            {
            (localQuantity > 0) &&(<>
            <Button 
                variant={localQuantity === 1 ? "ghost" : "default"}  
                size="icon" onClick={ () => handleAddClick(-1)} className="h-5 w-5">
                {
                localQuantity ===1 ? <Trash className="text-destructive w-6 h-6"/> : <Minus/>
                }
                            
            </Button>

                {
                localQuantity === 0 ? 
                <span className="font-semibold text-xs"> - </span> :
                <span className="font-semibold text-xs">{displayQuantity}</span>
                }
                

            <Button variant="default" size="icon" onClick={() => handleAddClick(1)} className="h-5 w-5" data-ph-event="add-plus-item-cart-button">
                <Plus/>
            </Button>
            {(showDelete)&&<Button variant="link" size={"icon"} onClick={() => handleRemoveClick()}>
                            <Trash className="text-destructive"/>
                            </Button>}
        </>
        )} 
        </div> 
    )
})